const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- address-dialog ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    container: { type: String, required: true },
    mailbox: String,
    address: { type: String, required: true },
    name: String,
    decisions: Array,
  }

  init() {
    this.state.kind = 'address'
  }

  pick(field, value) {
    this.state[field] = value
  }

  async spam() {
    const address = this.props.address
    await window.App.api(`container/${this.props.container}/sender_move`, {
      mailbox: this.props.mailbox,
      address: this.state.kind === 'domain' ? this.state.domain : address,
      decision: 'spam',
    })
    window.Dialog.close(true)
  }

  // An address goes back to the Inbox; a domain rule is removed.
  async notSpam(address) {
    const container = this.props.container
    const mailbox = this.props.mailbox
    if (address.includes('@')) await window.App.api(`container/${container}/sender_move`, { mailbox, address, decision: 'inbox' })
    else await window.App.api(`container/${container}/sender_forget`, { mailbox, address })
    window.Dialog.close(true)
  }

  beforeRender() {
    this.state.domain = this.props.address.split('@')[1] || ''
    this.state.spam = (this.props.decisions || [])
      .filter((item) => item.decision === 'spam')
      .map((item) => ({ address: item.address, label: item.address.includes('@') ? item.address : `Everyone at ${item.address}` }))
  }

  CSS = `:fez {
display:block;.who{display:flex;align-items:center;gap:var(--space-3)}.who-text{display:grid;min-width:0}.who-name{overflow:hidden;font-weight:var(--weight-semibold);text-overflow:ellipsis;white-space:nowrap}.who-address{overflow:hidden;color:var(--color-text-muted);font-size:var(--text-sm);text-overflow:ellipsis;white-space:nowrap}.section{margin-top:var(--space-5)}.section h3{margin:0 0 var(--space-2);color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.06em;text-transform:uppercase}.choice{display:flex;flex-wrap:wrap;gap:var(--space-1);margin-bottom:var(--space-2)}.spam{display:flex;align-items:center;gap:var(--space-3);padding:var(--space-2) 0}.spam + .spam{border-top:1px solid var(--color-border)}.spam-text{display:grid;flex:1;min-width:0}.spam-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.actions-spacer{flex:1}
}`

  HTML = `<div class="who">
<ui-avatar name={props.name || props.address} size="md"></ui-avatar>
<div class="who-text">
{#if props.name}<span class="who-name">{props.name}</span>{/if}
<span class="who-address">{props.address}</span>
</div>
</div>

<div class="section">
<h3>Spam</h3>
{#each state.spam as item}
<div class="spam" key={item.address}>
<ui-badge tone="danger" label="Spam"></ui-badge>
<div class="spam-text">
<span class="spam-value">{item.label}</span>
</div>
<ui-button size="sm" icon="tray" label="Not spam" onclick="fez.notSpam('{item.address}')"></ui-button>
</div>
{:else}
<div class="choice">
<ui-button size="sm" variant={state.kind === 'address' ? 'secondary' : 'ghost'} label={props.address} onclick="fez.pick('kind', 'address')"></ui-button>
<ui-button size="sm" variant={state.kind === 'domain' ? 'secondary' : 'ghost'} label="Everyone at {state.domain}" onclick="fez.pick('kind', 'domain')"></ui-button>
<span class="actions-spacer"></span>
<ui-button size="sm" variant="danger" icon="warning-octagon" label="Mark as spam" onclick="fez.spam()"></ui-button>
</div>
{/each}
</div>

<div class="dialog-actions">
<span class="actions-spacer"></span>
<ui-button icon="tray" label="Show mail" onclick="Dialog.close('show')"></ui-button>
<ui-button variant="primary" icon="pencil-simple" label="Write" onclick="Dialog.close('write')"></ui-button>
</div>`
};
}

Fez('address-dialog', __fez_component_0);

export default __fez_component_0;
